import { Store } from "@ngxs/store";
import { assign } from "lodash";

import * as API from "@hiptraveler/data-access/api";
import * as Itinerary from '..';
import { getWindowRef, globalStateManagementStoreKey } from "@hiptraveler/common";
import { updateBasicInfoSharedFields } from "./common";

export function responseBasicInfo(itineraryTripBasicInfo: Partial<API.BasicInfoData>) {

  const store = getWindowRef()?.[globalStateManagementStoreKey] as Store;
  const basicInfoSnapshot = store?.selectSnapshot(Itinerary.ItineraryState.basicInfo);
  const basicInfoState = assign({}, basicInfoSnapshot);

  if (itineraryTripBasicInfo?.autoSummary && !basicInfoState.autoSummary) {
    updateBasicInfoSharedFields(basicInfoState, itineraryTripBasicInfo);
  }

  return basicInfoState;
}
